import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const SicaanLogo = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        id="Sicaan"
        data-name="Sicaan"
        xmlns="http://www.w3.org/2000/svg"
        // viewBox="0 0 356.82 50"
        viewBox="0 0 1080 292.62"
        strokeWidth={0}
        fill="currentColor"
      >
        <g>
          <g>
            <path
              fill={'#dc9083'}
              d="M1015.72,171.16v50.4c0,1.73-1.4,3.13-3.13,3.13h-58.02c-1.73,0-3.13-1.4-3.13-3.13v-50.41
					c0-1.73,1.4-3.13,3.13-3.13h58.02C1014.32,168.03,1015.72,169.43,1015.72,171.16z"
            />
          </g>
          <g>
            <path
              fill={themeColor === 'light' ? '#0e0504' : '#fff'}
              d="M935.34,222.25c0,1.82-0.92,2.43-2.44,2.43h-60.27c-1.52,0-2.44-0.61-2.44-2.43l0.92-63.92v-28.91
					c0-13.39-5.78-19.18-14.61-19.18c-15.83,0-24.65,18.87-24.96,48.7l0.91,63.31c0,1.82-0.91,2.43-2.43,2.43h-59.96
					c-1.52,0-2.43-0.61-2.43-2.43l0.61-76.7l0.31-75.18c0-1.83,0.92-2.43,2.44-2.43h56.31c1.52,0,2.43,0.61,2.43,2.43l-0.91,15.83
					c10.65-16.44,29.83-21.91,48.7-21.91c37.14,0,56.92,24.35,56.92,57.83v36.22L935.34,222.25z"
            />
            <g>
              <path
                fill={themeColor === 'light' ? '#0e0504' : '#fff'}
                d="M193.21,181.06c0,27.81-25.05,46.51-62.33,46.51c-20.71,0-36.93-4.68-48.21-13.91
						c-11.9-9.72-18.08-24.3-18.38-43.32c0-1.73,1.25-2.97,2.98-2.97h11.57c1.72,0,2.97,1.24,2.97,2.95
						c0.58,29.12,16.73,43.29,49.38,43.29c27.45,0,44.51-12.13,44.51-31.66c0-22.56-23.81-26.63-49.02-30.94
						c-27.53-4.71-58.73-10.04-58.73-42.45c0-13.75,5.77-25.03,16.68-32.64c10.23-7.12,24.75-10.89,42-10.89
						c37.99,0,61.18,18.04,62.02,48.25c0,1.75-1.25,2.99-2.97,2.99H174.7c-1.73,0-2.98-1.24-2.98-2.95
						C170.29,83.47,142.84,79,126.61,79c-26.73,0-41.47,10.28-41.47,28.97c0,19.5,21.28,22.99,45.91,27.03
						C160.19,139.77,193.21,145.18,193.21,181.06z"
              />
            </g>
            <path
              fill={themeColor === 'light' ? '#0e0504' : '#fff'}
              d="M214.13,224.69c-0.65,0-1.3-0.91-1.3-1.83l0.43-78.83l-0.43-74.27c0-0.91,0.65-1.82,1.3-1.82h21.52
					c0.65,0,1.31,0.91,1.31,1.82l-0.44,73.97l0.44,79.14c0,0.92-0.65,1.83-1.31,1.83H214.13z"
            />
            <path
              fill={themeColor === 'light' ? '#0e0504' : '#fff'}
              d="M330.54,228.34c-48.7,0-76.7-31.96-76.7-81.58s28.01-82.49,77.31-82.49c39.57,0,64.83,22.83,67.88,56.61
					c0.31,1.22-0.61,2.13-1.82,2.13h-29.53c-1.22,0-2.13-0.92-2.43-2.13c-3.65-20.09-16.44-30.44-34.09-30.44
					c-27.09,0-39.88,19.48-39.88,56c0,37.74,13.09,55.7,39.88,56.01c20.09,0.31,33.18-12.48,35.31-35.31
					c0.31-1.22,1.22-2.13,2.44-2.13h30.44c1.22,0,2.13,0.91,1.83,2.13C398.42,202.47,371.33,228.34,330.54,228.34z"
            />
            <path
              fill={themeColor === 'light' ? '#0e0504' : '#fff'}
              d="M526.56,224.69c-1.22,0-2.43-1.22-2.43-2.43l0.61-15.83c-10.96,13.39-26.48,21.31-46.27,21.31
					c-44.44,0-67.88-35.31-67.88-80.97c0-45.35,26.18-81.88,68.79-81.88c19.48,0,34.7,7,45.35,19.78l-0.91-14.3
					c0-1.22,1.22-2.43,2.43-2.43h41.09c1.22,0,2.43,1.22,2.43,2.43l-0.61,76.09l0.61,75.79c0,1.22-1.22,2.43-2.43,2.43H526.56z
					 M491.25,197.29c22.22,0,34.09-16.74,34.4-49.92c0.31-33.48-11.57-51.75-33.48-52.05c-23.13-0.61-35.01,16.74-35.01,49.01
					C457.16,179.64,469.33,197.6,491.25,197.29z"
            />
            <g>
              <path
                fill={themeColor === 'light' ? '#0e0504' : '#fff'}
                d="M752,70.36c0-1.95-0.99-2.94-2.94-2.94h-50.22c-1.95,0-2.94,0.99-2.94,2.94l0.81,11.35
						c-10.57-11.5-24.8-17.33-42.31-17.33c-20.9,0-38.85,8.33-51.91,24.11c-12.39,14.97-19.21,35.66-19.21,58.27
						c0,49.49,26.97,81.47,68.69,81.47c18.56,0,34.34-6.83,45.71-19.78l-0.55,13.8c0,1.95,0.98,2.93,2.94,2.93h49
						c1.95,0,2.94-0.98,2.94-2.94l-0.61-75.17L752,70.36z M669.02,101.3h0.59c7.42,0,13.46,2.31,17.96,6.85
						c7.12,7.19,10.64,20.18,10.46,38.61c-0.29,29.76-10.06,44.86-29.03,44.86c-7.15,0.11-13.07-2.11-17.65-6.61
						c-7.54-7.42-11.36-20.8-11.36-39.76c0-17.62,3.61-30.11,10.73-37.12C655.32,103.6,661.48,101.3,669.02,101.3z"
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default SicaanLogo;
